import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=2c89782a&"
import script from "./ReportDetail.vue?vue&type=script&lang=ts&"
export * from "./ReportDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports